import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { location } from "../../../../api";
import NormalInput from "../../../../components/form/HorizontalNormalInput/index.jsx";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../components/card/card.jsx";
import { Form } from "react-bootstrap";

const permissions = {
  view: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "GINA Feature",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
  update: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
  create: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
  delete: [
    {
      name: "Machine Online Status",
    },
    {
      name: "Machine Health",
    },
    {
      name: "Machine Uptime",
    },
    {
      name: "Machine Alert Status",
    },
    {
      name: "Alert Count",
    },
    {
      name: "Alert Details",
    },
    {
      name: "MACHINE PROFILES",
    },
  ],
};
function ModalChangeRole({ open, onClose, onSubmit, row }) {
  const { getCompanyAccess } = useAuth();
  const [name, setName] = useState("");
  const [userRoleFeatureAccess, setUserRoleFeatureAccess] = useState([]);
  const [status, setStatus] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [companyAccess, setCompanyAccess] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  async function getLocations() {
    try {
      const res = await location.list("", true);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        setLocations(data);
        //console.log({ data });
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const config = getCompanyAccess();
  useEffect(() => {
    setCompanyAccess(config);
    getLocations();
  }, []);

  const dashboard_features = [
    "Machine Online Status",
    "Machine Health",
    "Machine Uptime",
    "Machine Alert Status",
  ].filter((item) => {
    return config.includes(item);
  });
  const alert_features = ["Alert Count", "Alert Details"].filter((item) => {
    return config.includes(item);
  });

  //const MPitem = config.includes("MACHINE PROFILES") ? "MACHINE PROFILES" : "";
  const MPitem = "MACHINE PROFILES";
  const Gina = config.includes("GINA Feature") ? "GINA Feature" : "";

  function filterAccesses(arr) {
    // check if arr is exist in userRoleFeatureAccess
    const filtered = companyAccess.filter((item) => {
      return arr.includes(item.name);
    });
    //console.log({ filtered });
    return filtered;
  }

  async function handleSubmit() {
    //validation
    let errors = [];
    if (!name) {
      errors.push("Enter role name");
    }
    if (errors.length > 0) {
      toast.error(errors.join("\n"));
      return;
    }
    onSubmit({
      name,
      userRoleFeatureAccess,
      accesses: selectedLocations,
      status,
    });
    if (!row) {
      clearFields();
    }
  }

  function clearFields() {
    setName("");
    setStatus("");
    setSelectedLocations([]);

    let prev = userRoleFeatureAccess.filter((x) => true);
    for (const ac of prev) {
      ac.can_view = false;
      ac.can_create = false;
      ac.can_update = false;
      ac.can_delete = false;
    }
    setUserRoleFeatureAccess(prev);
  }
  async function handleClose() {
    clearFields();
    onClose();
  }

  function emptyFeatureAccess() {
    //generate default access
    let accesses = [];
    for (const item of dashboard_features) {
      const accessx = {
        name: item,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false,
      };
      accesses.push(accessx);
    }
    for (const item of alert_features) {
      const accessx = {
        name: item,
        can_view: false,
        can_create: false,
        can_update: false,
        can_delete: false,
      };
      accesses.push(accessx);
    }
    const accessx = {
      name: "MACHINE PROFILES",
      can_view: false,
      can_create: false,
      can_update: false,
      can_delete: false,
    };
    accesses.push(accessx);
    const access_gina = {
      name: "GINA Feature",
      can_view: false,
      can_create: false,
      can_update: false,
      can_delete: false,
    };
    accesses.push(access_gina);
    return accesses;
  }

  async function getFeatureAccess() {
    setUserRoleFeatureAccess(emptyFeatureAccess());
  }

  function isAccessSelected(item, type) {
    if (dashboard_features.indexOf(item) >= 0) {
      if (type == "create" || type == "update" || type == "delete") {
        return false;
      }
    }
    if (item == "Alert Details" && (type == "create" || type == "delete")) {
      return false;
    }
    if (
      item == "Alert Count" &&
      (type == "create" || type == "update" || type == "delete")
    ) {
      return false;
    }
    return userRoleFeatureAccess.some(
      (sv) => item == sv.name && sv["can_" + type] == true
    );
  }

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatus(value);
  };

  function handleSelectAccess(item, type) {
    //console.log({ item, type, userRoleFeatureAccess });
    let prev = userRoleFeatureAccess.filter((x) => true);
    for (const ac of prev) {
      if (ac.name == item) {
        if (ac["can_" + type] == true) {
          ac["can_" + type] = false;
        } else {
          ac["can_" + type] = true;
        }
      }
    }

    setUserRoleFeatureAccess(prev);
  }

  useEffect(() => {
    getFeatureAccess();
  }, []);

  useEffect(() => {
    if (row) {
      setName(row.rolename);
      setSelectedLocations(row.accesses ? row.accesses : []);
      var n = row.accesses ? row.accesses.length : 0;

      for (var i = 0; i < n; i++) {
        const acc = row.accesses[i];
      }
      setStatus(row.is_active === true ? 1 : 0);

      let accesses = [];
      n = row.roleFeatureAccess ? row.roleFeatureAccess.length : 0;
      if (n == 0) {
        setUserRoleFeatureAccess(emptyFeatureAccess());
      } else {
        const empty = emptyFeatureAccess();
        const exclude = (arr1, arr2) =>
          arr1.filter(
            (o1) => arr2.map((o2) => o2.name).indexOf(o1.name) === -1
          );
        const new_array = row.roleFeatureAccess;
        new_array.forEach((e) => (e.name = e.page_name));

        for (var i = 0; i < n; i++) {
          const acc = row.roleFeatureAccess[i];
          const accessx = {
            name: acc.page_name,
            can_view: acc.can_view,
            can_create: acc.can_create,
            can_update: acc.can_update,
            can_delete: acc.can_delete,
          };
          accesses.push(accessx);
        }
        const not_exist = exclude(empty, row.roleFeatureAccess);
        not_exist.map((e) => {
          const accessx = {
            name: e.name,
            can_view: false,
            can_create: false,
            can_update: false,
            can_delete: false,
          };
          accesses.push(accessx);
        });
        setUserRoleFeatureAccess(accesses);
      }
    } else {
      setName("");
      setStatus("");

      setSelectedLocations([]);
      setUserRoleFeatureAccess(emptyFeatureAccess());
    }
  }, [row]);

  const handleSelectLocation = (id) => {
    if (selectedLocations.includes(id)) {
      setSelectedLocations((values) => values.filter((v) => v !== id));
    } else {
      setSelectedLocations((values) => [...values, id]);
    }
  };

  const isSelectedLocation = (id) => {
    return selectedLocations.includes(id);
  };

  const renderLocations = (locations) => {
    return (
      <>
        {locations.map((location, index) => {
          return (
            <div key={index}>
              <div
                className="form-check"
                onClick={() => handleSelectLocation(location.id)}
              >
                <input
                  className="form-check-input"
                  checked={isSelectedLocation(location.id)}
                  type="checkbox"
                  id={`${location.id}`}
                />
                <label className="form-check-label" htmlFor={location.id}>
                  {location.location_name}
                </label>
              </div>
              {location.sublocations && location.sublocations.length > 0 && (
                <div style={{ marginLeft: "20px" }}>
                  {renderLocations(location.sublocations)}
                </div>
              )}
            </div>
          );
        })}
      </>
    );
  };

  const selectPermission = (key, p) => {
    if (selectedPermissions.find((sp) => sp.name == p.key)) {
      const selected = [...selectedPermissions].filter((sp) => sp.id !== p.id);
      setSelectedPermissions(selected);
    } else {
      setSelectedPermissions((prev) => [...prev, p]);
    }
  };

  const isPermissionSelected = (p) => {
    if (selectedPermissions.find((sp) => sp.id == p.id)) {
      return true;
    } else {
      return false;
    }
  };
  return (
    <ConfirmationDlg
      open={open}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={handleSubmit}
      onClose={handleClose}
    >
      <div className="my-2">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            m: "auto",
          }}
        >
          <div style={{ px: 5, py: 4 }}>
            <NormalInput
              onchange={(e) => {
                setName(e.target.value);
              }}
              required
              type="text"
              value={name}
              label={"Name"}
            />

            <Card>
              <CardHeader>Location Access</CardHeader>
              <CardBody>
                <div>{renderLocations(locations)}</div>
              </CardBody>
            </Card>

            <Card>
              <CardHeader>Permissions</CardHeader>
              <CardBody>
                <div className="d-flex row">
                  {["view", "create", "update", "delete"].map((key, index) => {
                    return (
                      <div key={key} className="col-md-6">
                        <div
                          style={{
                            fontWeight: "bold",
                            textTransform: "capitalize",
                            marginBottom: 5,
                          }}
                        >
                          {" "}
                          {key}
                        </div>

                        {userRoleFeatureAccess.map((v, i) => {
                          return (
                            <Form.Check
                              key={i}
                              style={{ textTransform: "capitalize" }}
                              onChange={() => handleSelectAccess(v.name, key)}
                              type={"checkbox"}
                              label={v.name}
                              checked={isAccessSelected(v.name, key)}
                            />
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </CardBody>
            </Card>

            <div
              style={{ marginTop: "20px", display: "none" }}
              className={"row mx-2"}
            >
              <div className="col-sm-3">Features Access Permission</div>
              <div className="col-sm-9 border-theme border">
                <table className="table table-bordered table-sm">
                  <thead>
                    <th></th>
                    <th width={"60"}>View</th>
                    <th width={"60"}>Create</th>
                    <th width={"60"}>Update</th>
                    <th width={"60"}>Delete</th>
                  </thead>
                  <tbody>
                    <tr>
                      <td width="170" colSpan={5}>
                        DASHBOARD
                      </td>
                    </tr>
                    {dashboard_features.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>{item}</td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "view")}
                            >
                              <input
                                className="form-check-input"
                                checked={isAccessSelected(item, "view")}
                                onChange={() => {}}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "create")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "create")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "update")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "update")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "delete")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "delete")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan="5"></td>
                    </tr>
                    <tr>
                      <td colSpan={5}>ALERTS</td>
                    </tr>
                    {alert_features.map((item) => {
                      return (
                        <tr>
                          <td>{item}</td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "view")}
                            >
                              <input
                                disabled={true}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "view")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "create")}
                            >
                              <input
                                disabled={
                                  item == "Alert Details" ||
                                  item == "Alert Count"
                                }
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "create")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "update")}
                            >
                              <input
                                disabled={item == "Alert Count"}
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "update")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                          <td align="center">
                            <div
                              className="form-check"
                              onClick={() => handleSelectAccess(item, "delete")}
                            >
                              <input
                                disabled={
                                  item == "Alert Details" ||
                                  item == "Alert Count"
                                }
                                className="form-check-input"
                                onChange={() => {}}
                                checked={isAccessSelected(item, "delete")}
                                type="checkbox"
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    <tr>
                      <td colSpan="5"></td>
                    </tr>
                    <tr>
                      <td>Machine Profiles</td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "view")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "view")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "create")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "update")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "update")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(MPitem, "delete")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(MPitem, "delete")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Gina Features</td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "view")}
                        >
                          <input
                            className="form-check-input"
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "view")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "create")}
                        >
                          <input
                            className="form-check-input"
                            disabled={true}
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "create")}
                        >
                          <input
                            className="form-check-input"
                            disabled={true}
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                      <td align="center">
                        <div
                          className="form-check"
                          onClick={() => handleSelectAccess(Gina, "create")}
                        >
                          <input
                            className="form-check-input"
                            disabled={true}
                            onChange={() => {}}
                            checked={isAccessSelected(Gina, "create")}
                            type="checkbox"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style={{ mt: 0, mb: 4, display: "none" }} className={"row"}>
              <div className="col-sm-3">Status</div>
              <div className="col-sm-9">
                <div className="form-control">
                  <label>Status</label>
                  <select value={status} onChange={handleStatusChange}>
                    <option value="">- Select Status -</option>
                    <option value="1">Active</option>
                    <option value="2">InActive</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangeRole;
